import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@/shared/ui';

import type { FactsheetDetails } from '@/features/factsheet';
import ItemsTableRow from '@/features/factsheet/components/FactsheetView/FactsheetWindow/FactsheetBody/Tabs/ItemsTab/ItemsTableRow';
import useItemsTab from '@/features/factsheet/components/FactsheetView/FactsheetWindow/FactsheetBody/Tabs/ItemsTab/useItemsTab';
import { useIsFactsheetCompact } from '@/features/factsheet/state/useIsFactsheetCompact';
import Checkbox from '@/shared/ui/primitives/Checkbox';

const ItemsTab = ({ factsheet }: { factsheet: FactsheetDetails }) => {
  const { handleAllItemsSelection, allItemsSelected } = useItemsTab(factsheet);
  const isCompact = useIsFactsheetCompact();
  return (
    <Box sx={{ width: '100%' }}>
      <Typography
        size={isCompact ? 14 : undefined}
        sx={{ fontWeight: 'bold' }}
      >
        Item(s) Available {factsheet.symbols?.length}
      </Typography>
      <TableContainer>
        <Table
          stickyHeader
          aria-label='factsheet items table'
          size='small'
        >
          <TableHead>
            <TableRow
              sx={theme => ({
                '& td, & th': {
                  pb: 1,
                  fontWeight: 'bold',
                  borderBottom: `0.5px solid ${theme.palette.gx.text}`,
                  backgroundColor: 'gx.tileDark'
                }
              })}
            >
              <TableCell
                align='right'
                component='th'
                scope='row'
                sx={{ pl: 1, pr: 1, width: 24 }}
              >
                <Checkbox
                  checked={allItemsSelected}
                  sx={{ mb: '3px' }}
                  onChange={handleAllItemsSelection}
                />
              </TableCell>

              <TableCell>Code</TableCell>
              <TableCell>TimeRef</TableCell>
              <TableCell>PeriodType</TableCell>
              <TableCell>Period</TableCell>
              <TableCell>Alias</TableCell>
              <TableCell> TimeRef Detail</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              '&  .markets-table-row:nth-of-type(even)': {
                backgroundColor: 'gx.tileLight'
              },
              '&  .markets-table-row:nth-of-type(even) + td': {
                backgroundColor: 'gx.tileLight'
              }
            }}
          >
            {factsheet.symbols.map((symbol, index) => (
              <ItemsTableRow
                key={factsheet.code + index}
                code={factsheet.code}
                symbol={symbol}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
export default ItemsTab;
